/**
 * Paywall contract consumed by chat, phone shell and home. L12 implements PaywallProvider.
 * Mirrors PaywallService.presentRemotePaywall: if already premium → onEntitled immediately.
 */
import { createContext, useContext } from 'react';
import type { PremiumGate } from '@/domain';

export interface PresentOptions {
  /** Called once the entitlement is active (purchase or restore). */
  onEntitled?: () => void;
  /** Called when the player closes the paywall without purchasing. */
  onDismiss?: () => void;
  /** Analytics / A-B params (gate, source, episode_id…). */
  params?: Record<string, string | number | boolean | undefined>;
}

export interface PaywallAPI {
  isPremium: boolean;
  present(gate: PremiumGate, options?: PresentOptions): void;
  /** Stripe Customer Portal (manage / cancel). */
  openPortal(): Promise<void>;
  /** Re-reads premium_entitlements (after Checkout return, on focus). */
  refreshEntitlement(): Promise<boolean>;
}

export const PaywallContext = createContext<PaywallAPI | null>(null);

export function usePaywall(): PaywallAPI {
  const api = useContext(PaywallContext);
  if (!api) throw new Error('usePaywall outside PaywallProvider');
  return api;
}
